module.exports = __webpack_public_path__ + "files/c8dba7e4a36ddd974ae0df85db3eb47f.png";